import styled from '@emotion/styled';

import { CheckboxField } from '../../../Form/components/CheckboxField/CheckboxField';
import { Error } from '../../../Form/Form.styles';

export const NameFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-16);
`;

export const StyledError = styled(Error)`
  margin-top: calc(var(--spacing-8) * -1);
`;

export const SembonusCheckbox = styled(CheckboxField)`
  &::before {
    content: '';
    background: url('/m/sembonus.svg') no-repeat;
    width: 64px;
    height: 10px;
    display: inline-block;
    margin-right: var(--spacing-4);
  }
`;

export const TermsAndConditions = styled.div`
  font: var(--font-body-s-light);
  color: var(--color-neutral-70);
  text-align: center;

  button {
    color: inherit;
    font: inherit;
    padding-inline: var(--spacing-4);
  }
`;
